import Login from './components/login.vue';
import Challenge from './components/challenge.vue';
import ChangePassword from './components/change-password.vue';
import SetupQuestions from './components/setup-questions.vue';
import ChangeUsername from './components/change-username.vue';
import SelectDeliveryMethod from './components/select-delivery-method.vue';
import SelectDeliveryMethodChallenge from './components/select-delivery-method-challenge.vue';
import VerifyPhone from './components/verify-phone.vue';

export const routes = [
  { path: '/', redirect: { name: 'signin-login' } }, // default to login
  { path: '/signin', name: 'signin-login', component: Login, display: '', style: '' },
  { path: '/signin/challenge', name: 'signin-challenge', component: Challenge, display: '', style: '' },
  { path: '/signin/changepassword', name: 'signin-change-password', component: ChangePassword, display: '', style: '' },
  { path: '/signin/setupquestions', name: 'signin-setup-questions', component: SetupQuestions, display: '', style: '' },
  { path: '/signin/changeusername', name: 'signin-change-username', component: ChangeUsername, display: '', style: '' },
  { path: '/signin/selectdeliverymethod', name: 'signin-selectdeliverymethod', component: SelectDeliveryMethod, display: '', style: '' },
  { path: '/signin/challenge/selectdeliverymethod', name: 'signin-select-delivery-method-challenge', component: SelectDeliveryMethodChallenge, display: '', style: '' },
  { path: '/signin/verifyphone', name: 'signin-verify-phone', component: VerifyPhone, display: '', style: '' }
];